module.exports = __webpack_public_path__ + "img/txnComplete.ced239c3.svg";